import { formatShopifyPrice } from './theme.utils.js';

/**
 * Custom Quantity selector
 * When show_discounted_price is enabled in the buy button it will display the discounted price in the buy button
 */

function initializeQuantitySelector() {
  const buyButtonPrice = document.querySelector('.product-info__buy-buttons .discounted-price');
  document.querySelectorAll('.custom-select-wrapper').forEach(wrapper => {
      const originalSelect = wrapper.querySelector('.original-select');
      const trigger = wrapper.querySelector('.custom-select-trigger');
      const selectedValueSpan = wrapper.querySelector('.selected-value');
      const optionsList = wrapper.querySelector('.custom-options');
      const customOptions = optionsList.querySelectorAll('li');
      
      // Initialize selected value
      selectedValueSpan.textContent = originalSelect.options[originalSelect.selectedIndex].textContent;

      trigger.addEventListener('click', () => {
          optionsList.classList.toggle('open');
      });

      customOptions.forEach(option => {
          option.addEventListener('click', () => {
              const value = option.dataset.value;
              originalSelect.value = value;
              selectedValueSpan.innerHTML = option.innerHTML;
              optionsList.classList.remove('open');
              // Update selected class for styling
              customOptions.forEach(opt => opt.classList.remove('selected'));
              option.classList.add('selected');
              const originalTotal = option.dataset.price * option.dataset.value;
              const discountedTotal = option.dataset.discountedPrice * option.dataset.value;
              if (buyButtonPrice) {
                if (originalTotal == discountedTotal) {
                  buyButtonPrice.innerHTML = `<span>${formatShopifyPrice(originalTotal)}</span>`;
                  return;
                }
                buyButtonPrice.innerHTML = `<s class="text-subdued">${formatShopifyPrice(originalTotal, false)}</s> <span>${formatShopifyPrice(discountedTotal, false)}</span>`;
              }
          });
      });

      // Close when clicking outside
      document.addEventListener('click', (event) => {
          if (!wrapper.contains(event.target)) {
              optionsList.classList.remove('open');
          }
      });
    });
}


document.addEventListener("DOMContentLoaded", () => {
  initializeQuantitySelector(); 
});

document.addEventListener("variant:change", () => {
  initializeQuantitySelector();
});